module.exports = __webpack_public_path__ + "img/eva-manage.7b41abf5.svg";